<template>
	<form :class="className">
		<input
			type="text"
			:placeholder="$t('Common.search')"
			v-model="target"
			@keyUp.enter="go"
		/>
		<button @click.prevent="go" class="search-mag" value>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="#75787b"
			>
				<path
					d="M23.822 20.88l-6.353-6.354c.93-1.465 1.467-3.2 1.467-5.059.001-5.219-4.247-9.467-9.468-9.467s-9.468 4.248-9.468 9.468c0 5.221 4.247 9.469 9.468 9.469 1.768 0 3.421-.487 4.839-1.333l6.396 6.396 3.119-3.12zm-20.294-11.412c0-3.273 2.665-5.938 5.939-5.938 3.275 0 5.94 2.664 5.94 5.938 0 3.275-2.665 5.939-5.94 5.939-3.274 0-5.939-2.664-5.939-5.939z"
				/>
			</svg>
		</button>
	</form>
</template>
<script>
export default {
	name: 'Search',
	props: ['className'],
	data() {
		return {
			target: '',
		}
	},
	methods: {
		go() {
			window.open(
				'https://www.thefoodbank.ca/?s=' + this.target,
				'_blank'
			)
		},
	},
}
</script>

<style scoped lang="scss">
input {
	@extend %muli;
	@include border-radius(6px);
	width: 180px;
	height: 40px;
	background: #fff;
	box-shadow: none;
	border: 1px solid rgba(0, 0, 0, 0.04);
	outline: 0;
	max-width: 100%;
	padding-right: 50px;
	padding-left: 12px;
	font-size: 16px;
	margin-left: 20px;

	&.footer {
		margin-left: 0;
	}
}
button {
	width: 44px;
	position: absolute;
	z-index: 2;
	top: 0;
	right: 0;
	width: 50px;
	height: 100%;
	margin: 0;
	padding: 0;
	border: 0;
	background: 0 0;
	box-shadow: none;
}
svg {
	transition: 0.3s ease;
	width: 18px;
	height: 18px;
	margin-left: 7px;
	opacity: 0.3;
}

.footer {
	input {
		margin-left: 0;
		height: 50px;
		width: 100%;
	}
}

@include tabletLandscape {
	.footer {
		input {
			height: 32px;
			font-size: 1.7vw;
		}
	}
}

@include mobile {
	.footer {
		input {
			height: 50px;
			font-size: 4.3vw;
		}
	}
}
</style>
